import axios from 'axios';
import { LOGOUT } from '../actions/types';

const ROOT_URL = 'http://localhost:3001/api';
let instance = null;

export default class MobChowAPI {
  constructor() {
    if (!instance) {
      instance = this;
      this.apiClient = axios.create({
        baseURL: ROOT_URL,
      });
    }

    return instance;
  }

  static sum(data, field) {
    return data.reduce((count, item) => count + item[field], 0);
  }

  static getRangeApiValue(range) {
    const minDate = new Date();
    minDate.setDate(minDate.getDate() - range.value);
    return {
      gt: minDate,
    };
  }

  login({ domain, email, password }) {
    return this.apiClient.post('/merchants/login', { email, password, domain })
      .then((result) => {
        const { appId, clientKey } = result.data.keys;
        const token = result.data.token.id;
        this.apiClient.defaults.headers.common = {
          ...this.apiClient.defaults.headers.common,
          'X-App-Id': appId,
          'X-Client-Key': clientKey,
          Authorization: token,
        };
        return result;
      });
  }

  logout() {
    return this.apiClient.post('/users/logout');
  }

  getRevenue(range, filter = {}) {
    if (!filter.where) filter.where = {};

    if (range && range.value > 0) {
      filter.where.createdAt = MobChowAPI.getRangeApiValue(range);
    }

    filter.fields = 'total';

    return this.apiClient.get(`/orders?filter=${JSON.stringify(filter)}`)
      .then(result => ({
        total: this.constructor.sum(result.data, 'total'),
      }));
  }

  getInstallationCount(range, filter = {}) {
    if (!filter.where) filter.where = {};

    filter.fields = 'created';

    if (range && range.value > 0) {
      filter.where.created = MobChowAPI.getRangeApiValue(range);
    }

    return this.apiClient.get(`/installations?filter=${JSON.stringify(filter)}`);
  }

  getUserCount(range, filter = {}) {
    if (!filter.where) filter.where = {};

    filter.fields = 'createdAt';

    if (range && range.value > 0) {
      filter.where.createdAt = MobChowAPI.getRangeApiValue(range);
    }

    return this.apiClient.get(`/users?filter=${JSON.stringify(filter)}`);
  }

  getOrdersCount(range, filter = {}) {
    if (!filter.where) filter.where = {};
    filter.fields = 'createdAt';

    if (range && range.value > 0) {
      filter.where.createdAt = MobChowAPI.getRangeApiValue(range);
    }
    return this.apiClient.get(`/orders/?filter=${JSON.stringify(filter)}`);
  }

  getCustomers(filter = {}) {
    if (!filter.limit) filter.limit = 25;
    if (!filter.order) filter.order = 'createdAt DESC';

    return this.apiClient.get(`/users?filter=${JSON.stringify(filter)}`);
  }

  getOrders(filter = {}) {
    if (!filter.limit) filter.limit = 25;
    if (!filter.order) filter.order = 'createdAt DESC';

    return this.apiClient.get(`/orders?filter=${JSON.stringify(filter)}`);
  }
}



// WEBPACK FOOTER //
// ./src/data/MobChowAPI.js